import PaymentMethods from './payment-methods';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import ManageAccountModal from './ManageAccountModal';

export default {
  PaymentMethods,
  DeleteConfirmationModal,
  ManageAccountModal,
};
